import { type CaseReducer } from '@reduxjs/toolkit';

import { type SessionState } from '../types';

const logoutImpersonationCase: CaseReducer<SessionState> = state => {
  state.credentials.impersonationToken = undefined;
};

export { logoutImpersonationCase };
